import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import placementTestReportFilterService from './PlacementTestReportFilterService';

class ErrorsPerGrammarChartService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      data: [],
    });
  }

  load = action(() => {
    this.fetch
      .fetch({
        url: '/placement-test-report/errors-per-grammar',
        query: {
          ...placementTestReportFilterService.form.getValues(),
          ...(placementTestReportFilterService.form.getValue('periodStart') &&
            placementTestReportFilterService.form.getValue('periodEnd') && {
              periodStart: placementTestReportFilterService.form.getValue('periodStart').format('YYYY-MM-DD'),
              periodEnd: placementTestReportFilterService.form.getValue('periodEnd').format('YYYY-MM-DD'),
            }),
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.data = this.fetch.data;
        } else {
          this.data = [];
        }
      });
  });
}

const errorsPerGrammarChartService = new ErrorsPerGrammarChartService();
export default errorsPerGrammarChartService;
